module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-container"
  }, [_c('p', {
    staticClass: "paraHead",
    staticStyle: {
      "font-size": "26px"
    }
  }, [_vm._v("求助消息详情\n    "), _c('Span', {
    staticClass: "paraHead"
  }, [_c('Button', {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.returnPage.apply(null, arguments)
      }
    }
  }, [_vm._v("返回之前页面")])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "paraHead"
  }, [_vm._v("盲人基本信息")]), _vm._v(" "), _c('Card', {
    staticClass: "bodyCard"
  }, [_c('Row', {
    attrs: {
      "gutter": 64
    }
  }, [_c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100px",
      "height": "100px",
      "background-color": "#fff"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": _vm.helpInfo.avatarUrl,
      "alt": "headUrl"
    }
  })])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('p', {
    staticClass: "basicInfo"
  }, [_vm._v("\n          昵称:\n          "), _c('span', {
    staticClass: "content",
    staticStyle: {
      "color": "rgba(56, 56, 56, 1)"
    }
  }, [_vm._v(_vm._s(_vm.helpInfo.nickname))])]), _vm._v(" "), _c('p', {
    staticClass: "basicInfo"
  }, [_vm._v("\n          加入时间:\n          "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.helpInfo.createTime))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('p', {
    staticClass: "basicInfo"
  }, [_vm._v("\n          提问数量:\n          "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', {
    staticClass: "answerInfo"
  }, [_vm._v(_vm._s(_vm.helpInfo.data.pageTotal))]), _vm._v("条\n          ")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "help-history"
  }, [_c('img', {
    attrs: {
      "src": "/static/rightArrow.png",
      "alt": ""
    },
    on: {
      "click": _vm.goHistory
    }
  })])], 1), _vm._v(" "), _c('p', {
    staticClass: "paraHead"
  }, [_vm._v("问题内容")]), _vm._v(" "), _c('Card', {
    staticClass: "bodyCard"
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.helpInfo.imageUrl),
      expression: "helpInfo.imageUrl"
    }],
    attrs: {
      "span": "4"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "180px",
      "height": "320px",
      "background-color": "#fff"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "180px",
      "height": "320px"
    },
    attrs: {
      "src": _vm.helpInfo.imageUrl,
      "onerror": "javascript:this.src='/static/imgError.png'",
      "alt": "图片加载失败"
    }
  })]), _vm._v(" "), _c('Button', {
    staticClass: "buttonStyle",
    attrs: {
      "type": "text",
      "icon": "ios-download-outline"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.downPic.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("保存")])]), _vm._v(" "), _c('Button', {
    staticClass: "buttonStyle",
    attrs: {
      "type": "text",
      "icon": "ios-search-strong"
    },
    on: {
      "click": function($event) {
        _vm.picModal = true
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("放大")])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('p', {
    staticClass: "basicInfo"
  }, [_vm._v("求助文字")]), _vm._v(" "), _c('div', {
    staticClass: "innerCard"
  }, [_c('Card', {
    staticStyle: {
      "box-shadow": "0 5px 10px gray"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "line-height": "20px",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(!_vm.helpInfo.helpText ? _vm.helpInfo.helpText : "无"))])])], 1), _vm._v(" "), _c('p', {
    staticClass: "basicInfo"
  }, [_vm._v("求助语音")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.helpInfo.voiceUrl),
      expression: "helpInfo.voiceUrl"
    }],
    staticClass: "innerCard"
  }, [_c('audio', {
    attrs: {
      "controls": "controls",
      "preload": "none",
      "src": _vm.helpInfo.voiceUrl
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.helpInfo.voiceUrl),
      expression: "!helpInfo.voiceUrl"
    }],
    staticClass: "innerCard"
  }, [_c('Card', {
    staticStyle: {
      "box-shadow": "0 5px 10px gray",
      "height": "50px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "line-height": "20px",
      "text-align": "center"
    }
  }, [_vm._v("无")])])], 1), _vm._v(" "), _c('p', {
    staticClass: "basicInfo"
  }, [_vm._v("求助视频")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.helpInfo.videoUrl),
      expression: "helpInfo.videoUrl"
    }],
    staticClass: "innerCard"
  }, [_c('video', {
    staticStyle: {
      "max-height": "300px"
    },
    attrs: {
      "controls": "controls",
      "src": _vm.helpInfo.videoUrl
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.helpInfo.videoUrl),
      expression: "!helpInfo.videoUrl"
    }],
    staticClass: "innerCard"
  }, [_c('Card', {
    staticStyle: {
      "box-shadow": "0 5px 10px gray",
      "height": "50px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "line-height": "20px",
      "text-align": "center"
    }
  }, [_vm._v("无")])])], 1), _vm._v(" "), _c('p', {
    staticClass: "basicInfo"
  }, [_vm._v("求助进度")]), _vm._v(" "), _c('div', {
    staticClass: "innerCard"
  }, [_c('Progress', {
    attrs: {
      "percent": _vm.percentNum,
      "status": "active"
    }
  }), _vm._v(" "), _c('Button', {
    staticStyle: {
      "font-size": "20px"
    },
    attrs: {
      "icon": "android-call",
      "type": "text"
    }
  }), _vm._v(" "), _c('span', [_vm._v("客服回答:   无")])], 1), _vm._v(" "), _c('p', {
    staticClass: "basicInfo"
  }, [_vm._v("求助时间")]), _vm._v(" "), _c('div', {
    staticClass: "innerCard"
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.helpInfo.createTime))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('div', {
    staticClass: "rightCard"
  }, [_c('div', {
    staticStyle: {
      "height": "40px",
      "background-color": "rgba(42, 130, 228, 1)"
    }
  }, [_c('p', {
    staticClass: "rightHead"
  }, [_vm._v("客服回答面板")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_vm._v("快捷选项")]), _vm._v(" "), _c('Button', {
    staticClass: "quickButton",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.chooseItem(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.quickItem1))]), _vm._v(" "), _c('Button', {
    staticClass: "quickButton",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.chooseItem(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.quickItem2))]), _vm._v(" "), _c('Button', {
    staticClass: "quickButton",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.chooseItem(3)
      }
    }
  }, [_vm._v(_vm._s(_vm.quickItem3))]), _vm._v(" "), _c('Button', {
    staticClass: "quickButton",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.chooseItem(4)
      }
    }
  }, [_vm._v(_vm._s(_vm.quickItem4))]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "width": "350px",
      "height": "1px",
      "background-color": "rgba(42, 130, 228, 1)",
      "margin": "10px auto",
      "border": "none"
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.replyText),
      expression: "replyText"
    }],
    staticClass: "rightInnerCard",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.replyText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.replyText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('Button', {
    staticClass: "submitButton",
    class: {
      'subBtn': _vm.successBtn
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "~click": function($event) {
        return _vm.successSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("成功提交")])], 1)])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "paraHead"
  }, [_vm._v("志愿者回复")]), _vm._v(" "), _c('Row', {
    staticClass: "code-row-bg",
    staticStyle: {
      "width": "96%"
    },
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, _vm._l((_vm.offerHelpInfos), function(item) {
    return _c('Col', {
      key: item.id,
      staticStyle: {
        "min-width": "450px"
      },
      attrs: {
        "span": "9"
      }
    }, [_c('div', {
      staticClass: "answerBox"
    }, [_c('div', {
      staticStyle: {
        "height": "30px",
        "background-color": "#2366B0"
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "14px",
        "color": "#fff",
        "text-align": "center"
      }
    })]), _vm._v(" "), _c('Row', {
      staticClass: "code-row-bg",
      attrs: {
        "type": "flex"
      }
    }, [_c('Col', [_c('img', {
      staticClass: "volunteerHead",
      attrs: {
        "src": item.avatarUrl,
        "alt": "头像加载失败",
        "onerror": "javascript:this.src='/static/imgError.png'"
      }
    })]), _vm._v(" "), _c('Col', [_c('p', {
      staticStyle: {
        "font-size": "14px",
        "margin": "15px"
      }
    }, [_vm._v("昵称:\n              "), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(item.nickname))])])]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "4",
        "offset": "5"
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "14px",
        "color": "#cccccc",
        "margin-top": "30px"
      }
    }, [_vm._v("详细信息")])]), _vm._v(" "), _c('Col', {
      attrs: {
        "offset": "1"
      }
    }, [_c('Button', {
      staticClass: "rightBtn",
      attrs: {
        "icon": "android-arrow-forward"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.volunterDetailBtn2.apply(null, arguments)
        }
      }
    })], 1)], 1), _vm._v(" "), _c('hr', {
      staticStyle: {
        "height": "1px",
        "background-color": "#cccccc",
        "border": "none"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "answerList"
    }, [_vm._v("回复内容:")]), _vm._v(" "), _c('Card', {
      staticClass: "textCard"
    }, [_c('p', {
      staticStyle: {
        "font-size": "16px",
        "line-height": "20px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(item.helpText))])]), _vm._v(" "), _c('p', {
      staticClass: "answerList"
    }, [_vm._v("回复时间:")]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "16px",
        "margin-left": "10%"
      }
    }, [_vm._v(_vm._s(_vm.format(item.updateTime)))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "16px",
        "margin-left": "10%"
      }
    }, [_vm._v("差值:" + _vm._s(_vm.diffTime(item.updateTime - item.createTime)))]), _vm._v(" "), _c('p', {
      staticClass: "answerList",
      staticStyle: {
        "margin-top": "20px"
      }
    }, [_vm._v("此次积分")]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "16px",
        "margin": "10px",
        "margin-left": "30%"
      }
    }, [_vm._v("爱心积分:   +" + _vm._s(item.point))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "16px",
        "margin": "10px",
        "margin-left": "30%"
      }
    }, [_vm._v("服务积分:   +" + _vm._s(item.gradePoint))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "16px",
        "margin": "10px",
        "margin-left": "30%"
      }
    }, [_vm._v("时间银行:   +" + _vm._s(item.timebank) + "s")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "block",
        "margin-left": "50%"
      }
    }, [_c('Button', {
      staticClass: "changeText",
      attrs: {
        "icon": "paintbrush",
        "type": "primary"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.volunterDetailBtn2.apply(null, arguments)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v("修改数据")])], 1)], 1)])
  }), 1), _vm._v(" "), _c('Modal', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "width": "1000px",
      "footer-hide": ""
    },
    model: {
      value: (_vm.picModal),
      callback: function($$v) {
        _vm.picModal = $$v
      },
      expression: "picModal"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "1000px",
      "max-height": "670px"
    },
    attrs: {
      "src": _vm.helpInfo.imageUrl,
      "alt": "图片加载失败"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59c66bae","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--1-1!./src/components/message-blocks/helpMessageDetail.vue
// module id = ZXMG
// module chunks = 0